import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Calendar from "react-calendar";
import "src/styles/Calendar.css"; // css import
import moment from "moment";
import "moment/locale/ko";
import Body from "src/components/common/Body";
import Box from "src/components/common/Box";
import Button from "src/components/common/Button";
import TodayItem from "src/components/schedule/TodayItem";
import styled from "styled-components";
import { useScheduleDayListQuery, useScheduleListQuery } from "src/api/scheduleAPI";
import { useAppSelector } from "src/store/actions/action";
import AlarmButton from "src/components/common/AlarmButton";
import IconButton from "src/components/common/IconButton";
import SVG from "src/utils/SVG";

function schedule() {
  // 초기 값 세팅
  const userInfo = useAppSelector((state) => state.userReduce.userInfo);
  const [init, setInit] = useState({ apiSkip: true });
  const { apiSkip } = init;

  const [date, setDate] = useState(new Date());
  const [mark, setMark]: any = useState([]);
  const [hasAlarm, setHasAlarm] = useState(false);
  const navigate = useNavigate();

  const [dayScheduleTotal, setDayScheduleTotal] = useState<number>();
  const [noticeDayScheduleTotal, setNoticeDayScheduleTotal] = useState<number>();

  const [selectedMonth, setSelectedMonth] = useState<Date>(new Date());

  const scheduleList = useScheduleListQuery(moment(selectedMonth).format("YYYYMM"), { skip: apiSkip });

  useEffect(() => {
    setInit({
      ...init,
      apiSkip: false,
    });
    if (scheduleList.isSuccess) {
      const markList = [];
      for (let i = 0; i < scheduleList.data.length; i++) {
        markList.push(scheduleList.data[i]);
      }
      setMark(markList);
    }
  }, [scheduleList]);

  const [currentView, setCurrentView] = useState("month");

  const childrenTotalDataFunc = (asTotal: number, noticeTotal: number) => {
    setDayScheduleTotal(asTotal);
    setNoticeDayScheduleTotal(noticeTotal);
  };

  return (
    <>
      <header>
        <div>
          <Button variant="text" className="btn-back no-ico">
            일정
          </Button>
        </div>
        <div className="btn-box">
          <AlarmButton />
          <IconButton btnName="마이페이지" className="user" onClick={() => navigate("/profile/" + userInfo.user_id)}>
            <SVG name="userBlack" />
          </IconButton>
        </div>
      </header>

      <Body isTabbar={true}>
        <Box pd="20px 15px">
          <Calendar
            onChange={setDate}
            minDetail="decade"
            formatMonthYear={(locale, date) => moment(date).format("YYYY년 M월")}
            formatDay={(locale, date) => moment(date).format("D")} // 날 표시할때 '일', 0 제외하고 숫자만 보이도록 설정
            value={date}
            showNeighboringMonth={false} //  전달, 다음달 날짜 표시 안함
            calendarType="US" // 주의 첫번째 요일 일요일부터 시작
            tileContent={({ date, view }) => {
              const html: any = [];
              if (view === "month") {
                // 날짜 타일에 컨텐츠 추가하기
                // 추가할 html 태그를 변수 초기화
                // 현재 날짜가 배열(mark)에 있다면, 클래스 dot을 가진 div 태그 추가
                if (mark.find((x: any) => x.visit_date === moment(date).format("YYYY-MM-DD") && x.schedule_type === "A")) {
                  html.push(<div className="dot"></div>);
                }
                if (mark.find((x: any) => x.visit_date === moment(date).format("YYYY-MM-DD") && x.schedule_type === "N")) {
                  html.push(<div className="dot notice"></div>);
                }
              }
              return (
                <>
                  <div className="dot-wrap">{html}</div>
                </>
              );
            }}
            onViewChange={({ view }) => {
              setCurrentView(view);
            }}
            onClickMonth={(value) => {
              setSelectedMonth(value);
              setDate(value);
            }}
          />
        </Box>

        {currentView === "month" ? (
          <>
            <TodayScheduleTitle>
              <div className="today">{moment(date).locale("ko").format("M. D dd")}</div>
              <div>
                {dayScheduleTotal! > 0 && <span className="dot-num">{dayScheduleTotal}</span>}
                {noticeDayScheduleTotal! > 0 && <span className="dot-num notice">{noticeDayScheduleTotal}</span>}
              </div>
            </TodayScheduleTitle>
            <TodayScheduleSet>
              <TodayItem date={date} parentFunc={childrenTotalDataFunc} />
            </TodayScheduleSet>
          </>
        ) : (
          ""
        )}
      </Body>
    </>
  );
}

const TodayScheduleTitle = styled.div`
  padding: 0 15px;
  margin-top: 20px;
  ${({ theme }) => theme.flexBox.flexMixin()}
  .today {
    font-size: 16px;
    font-weight: 500;
  }
  .dot-num {
    display: inline-block;
    min-width: 36px;
    height: 24px;
    line-height: 24px;
    padding: 0 5px;
    border-radius: 12px;
    background-color: ${({ theme }) => theme.color.markAs};
    color: #fff;
    text-align: center;
    &.notice {
      background-color: ${({ theme }) => theme.color.markNotice};
    }
    & + .dot-num {
      margin-left: 5px;
    }
  }
`;

const TodayScheduleSet = styled.ul`
  padding: 0 15px;
  > li {
    padding: 15px 15px 15px 30px;
    margin-top: 15px;
    border-radius: 4px;
    background-color: #f4f5f7;
    &.no-result {
      padding: 15px;
    }
  }
`;

export default schedule;
